module.exports = __webpack_public_path__ + "static/banner-e4af1d6a295a377fee814aea7e61dbaa.png";